<template>
  <div>
    <AlertLayout v-if="currentTab === 'blood-units'" title="Reminders!" message="Incorrect screening results could be fatal to recipients. Kindly ensure you enter the correct
    results and information below <br> Kindly note that you can only process one unit at at a time" type="warning" />
    <AlertLayout v-if="currentTab === 'patient-samples'" title="Reminders!"
      message="Kindly note that only valid samples are listed below. Each sample has a 7-day validity period."
      type="warning" />
    <AlertLayout v-if="currentTab === 'live-counter'" title="Reminders!" message="Kindly note that the default stats below are based on today's date. <br> 
        Kindly note that the stats below are ordered in the following manner SUPPLY/ DEMAND/ TARGET DEFICIT <br> 
        Kindly note that the stats below can be downloaded to an excel file format for further analysis"
      type="warning" />
    <div class="flex flex-wrap items-center justify-between py-1 pb-4">
      <div class="flex items-center space-x-4">
        <div class="relative">
          <button id="dropdownRadioButton"
            class="inline-flex items-center px-6 py-2 text-gray-400 bg-white border border-gray-300 rounded-md"
            type="button" @click="toggleDropdown">
            <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
              fill="none" viewBox="0 0 24 24">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="2"
                d="M18.796 4H5.204a1 1 0 0 0-.753 1.659l5.302 6.058a1 1 0 0 1 .247.659v4.874a.5.5 0 0 0 .2.4l3 2.25a.5.5 0 0 0 .8-.4v-7.124a1 1 0 0 1 .247-.659l5.302-6.059c.566-.646.106-1.658-.753-1.658Z" />
            </svg>
            Filters
            <svg class="w-2.5 h-2.5 ms-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
              viewBox="0 0 10 6">
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m1 1 4 4 4-4" />
            </svg>
          </button>
          <!-- start dropdown filter -->
          <template v-if="currentTab === 'blood-units'">
            <div v-show="isDropdownOpen" id="filterDropdown"
              class="absolute z-10 p-4 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-80">
              <div class="flex">
                <button type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="cancelFilters" aria-label="Close">
                  <span class="sr-only">Dismiss</span>
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label for="donationProcess" class="block mb-2 text-sm font-medium text-gray-900">Blood Group
                  </label>
                  <select v-model="filters.bloodGroup"
                    class="block w-full px-1 py-2 text-gray-900 border border-gray-200 rounded-md bg-gray-50 dark:placeholder-gray-400">
                    <option disabled selected>Select blood group</option>
                    <option v-for="group in bloodGroups" :key="group.blood_group_id" :value="group.blood_group_id">
                      {{ group.description }}
                    </option>
                  </select>
                </div>
                <!-- <div class="mb-4">
                  <label for="dateRegistered" class="block mb-2 text-sm font-medium text-gray-900">Donation Date</label>
                  <input type="text" id="dateRegistered" v-model="filters.dateRegistered"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    placeholder="YYYY-MM-DD">
                </div> -->
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Donation Date
                    From</label>
                  <input type="date" v-model="filters.start_date" id="table-search"
                    class="w-full px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                    placeholder="Date Range" />
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Donation Date
                    To</label>
                  <input type="date" v-model="filters.end_date" id="table-search"
                    class="w-full px-4 py-2 text-gray-800 border border-gray-300 rounded-sm dark:border-gray-300 dark:placeholder-gray-400"
                    placeholder="Date Range" />
                </div>
                <div class="mb-4">
                  <label for="donationProcess" class="block mb-2 text-sm font-medium text-gray-900">Donation
                    Process</label>
                  <select id="donationProcess" v-model="filters.donationProcess"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select</option>
                    <option value="Normal">Normal</option>
                    <option value="Apheresis">Apheresis</option>
                  </select>
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Status</label>
                  <select id="statusFilter" v-model="filters.status"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select</option>
                    <option value="Unscreened">Unscreened</option>
                    <option value="Ongoing Screening">Ongoing Screening</option>
                    <option value="Pending Approval">Pending Approval</option>
                    <option value="Approved">Approved</option>
                    <option value="Disposed">Disposed</option>
                    <option value="Pending Disposal">Pending Disposal</option>
                  </select>
                </div>
                <div class="flex justify-end space-x-2">
                  <button type="button" @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                    Cancel
                  </button>
                  <button type="submit"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-custom-yellow hover:bg-custom-yellow-dark">
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>

          <template v-if="currentTab === 'external-units'">
            <div v-show="isDropdownOpen" id="filterDropdown"
              class="absolute z-10 p-4 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-80">
              <div class="flex">
                <button type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="cancelFilters" aria-label="Close">
                  <span class="sr-only">Dismiss</span>
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label for="donationProcess" class="block mb-2 text-sm font-medium text-gray-900">Blood Group
                  </label>
                  <select v-model="filters.bloodGroup"
                    class="block w-full px-1 py-2 text-gray-900 border border-gray-200 rounded-md bg-gray-50 dark:placeholder-gray-400">
                    <option disabled selected>Select blood group</option>
                    <option v-for="group in bloodGroups" :key="group.blood_group_id" :value="group.description">
                      {{ group.description }}
                    </option>
                  </select>
                </div>
                <div class="mb-4">
                  <label for="dateRegistered" class="block mb-2 text-sm font-medium text-gray-900">Donation Date</label>
                  <input type="text" id="dateRegistered" v-model="filters.dateRegistered"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    placeholder="YYYY-MM-DD">
                </div>
                <div class="mb-4">
                  <label for="donationProcess" class="block mb-2 text-sm font-medium text-gray-900">Donation
                    Process</label>
                  <select id="donationProcess" v-model="filters.donationProcess"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select</option>
                    <option value="Normal">Normal</option>
                    <option value="Apheresis">Apheresis</option>
                  </select>
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Status</label>
                  <select id="statusFilter" v-model="filters.status"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select</option>
                    <option value="Unscreened">Unscreened</option>
                    <option value="Ongoing Screening">Ongoing Screening</option>
                    <option value="Pending Approval">Pending Approval</option>
                    <option value="Approved">Approved</option>
                    <option value="Disposed">Disposed</option>
                    <option value="Pending Disposal">Pending Disposal</option>
                  </select>
                </div>
                <div class="flex justify-end space-x-2">
                  <button type="button" @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                    Cancel
                  </button>
                  <button type="submit"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-custom-yellow hover:bg-custom-yellow-dark">
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>


          <!-- live counter filter -->

          <template v-if="currentTab === 'live-counter'">
            <div v-show="isDropdownOpen" id="filterDropdown"
              class="absolute z-10 p-4 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-80">
              <div class="flex">
                <button type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="cancelFilters" aria-label="Close">
                  <span class="sr-only">Dismiss</span>
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label for="donationProcess" class="block mb-2 text-sm font-medium text-gray-900">Blood Group
                  </label>
                  <select v-model="filters.bloodGroup"
                    class="block w-full px-1 py-2 text-gray-900 border border-gray-200 rounded-md bg-gray-50 dark:placeholder-gray-400">
                    <option disabled selected>Select blood group</option>
                    <option v-for="group in bloodGroups" :key="group.blood_group_id" :value="group.description">
                      {{ group.description }}
                    </option>
                  </select>
                </div>
                <!-- Unit Product Filter -->
                <div class="mb-4">
                  <label for="unitProduct" class="block mb-2 text-sm font-medium text-gray-900">Unit Product</label>
                  <select v-model="filters.unitProduct"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select unit product</option>
                    <option v-for="product in bloodProducts" :key="product.unit_product_id" :value="product.name">
                      {{ product.name }}
                    </option>
                  </select>
                </div>
                <div class="mb-4">
                  <label for="dateRegistered" class="block mb-2 text-sm font-medium text-gray-900">Donation Date</label>
                  <input type="date" id="dateRegistered" v-model="filters.dateRegistered"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5"
                    placeholder="YYYY-MM-DD">
                </div>
                <div class="mb-4">
                  <label for="statusFilter" class="block mb-2 text-sm font-medium text-gray-900">Status</label>
                  <select id="statusFilter" v-model="filters.status"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                    <option value="" disabled selected>Select</option>
                    <option value="Okay">Okay</option>
                    <option value="Assigned">Assigned</option>
                    <option value="Pending Approval">Issued</option>
                    <option value="Transfused">Transfused</option>
                    <option value="Expired">Expired</option>
                    <option value="Segregated">Segregated</option>
                  </select>
                </div>
                <div class="flex justify-end space-x-2">
                  <button type="button" @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                    Cancel
                  </button>
                  <button type="submit"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-custom-yellow hover:bg-custom-yellow-dark">
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>

          <!-- external issuence -->
          <template v-if="currentTab === 'external-issuance'">
            <div v-show="isDropdownOpen" id="filterDropdown"
              class="absolute z-10 p-4 mt-2 bg-white border border-gray-300 rounded-lg shadow-lg w-80">
              <div class="flex">
                <button type="button"
                  class="ml-auto -mx-1.5 -my-1.5 p-1.5 inline-flex text-gray-500 items-center justify-end h-8 w-8 hover:text-custom-yellow"
                  @click="cancelFilters" aria-label="Close">
                  <span class="sr-only">Dismiss</span>
                  <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 14 14">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                  </svg>
                </button>
              </div>
              <form class="max-w-sm mx-auto" @submit.prevent="applyFilters">
                <div class="mb-4">
                  <label for="facilty" class="block mb-2 text-sm font-medium text-gray-900">Facility</label>
                  <input type="text" id="facilty" v-model="filters.facilty"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                </div>
                <div class="mb-4">
                  <label for="dateIssued" class="block mb-2 text-sm font-medium text-gray-900">Issue Date</label>
                  <input type="date" id="dateIssued" v-model="filters.dateIssued"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2.5">
                </div>
                <div class="flex justify-end space-x-2">
                  <button type="button" @click="cancelFilters"
                    class="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-lg hover:bg-gray-100">
                    Cancel
                  </button>
                  <button type="submit"
                    class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-custom-yellow hover:bg-custom-yellow-dark">
                    Filter
                  </button>
                </div>
              </form>
            </div>
          </template>

        </div>

        <div class="relative flex">
          <input type="text" v-model="searchQuery" id="table-search"
            class="px-4 py-2 text-gray-800 border border-gray-300 rounded-md dark:border-gray-300 dark:placeholder-gray-400"
            placeholder="Search..." />
        </div>
      </div>
      <div class="flex items-center mt-4 space-x-4 sm:mt-0">
        <template v-if="currentTab === 'blood-units'">
          <CustomButton label="New Unit" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="handleNewUnitRegistration" />
        </template>
        <template v-if="currentTab === 'external-units'">
          <CustomButton label="New External Unit" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="handleNewExternalUnitRegistration" />
        </template>
        <template v-else-if="currentTab === 'live-counter'">
          <CustomButton label="10 Days to Expiry" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="filterExpiry()" />
          <CustomButton label="Live Counter Tally" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="handleLiveCounter" />
        </template>
        <template v-else-if="currentTab === 'blood-pooling'">
          <CustomButton label="Initiate Pooling" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="handleBloodPooling" />
        </template>
        <template v-else-if="currentTab === 'external-issuance'">
          <CustomButton label="new unit issuance" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="handleNewExterbalUnitIssuance" />
        </template>
        <template v-else-if="currentTab === 'inventory-records'">
          <CustomButton label="Add New Items" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="openAddItemModal" />
        </template>
        <template v-else-if="currentTab === 'item-types'">
          <CustomButton label="Add New Item" :icon-path="'M5 12h14m-7 7V5'" bg-class="bg-custom-yellow"
            @click="openAddItemTypeModal" />
        </template>
      </div>
      <div v-if="isPageLoading" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
        <div class="w-12 h-12 border-t-4 border-b-4 border-yellow-500 rounded-full animate-spin"></div>
      </div>
    </div>
    <div class="flex mb-4 border-b tabs">
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'blood-units' }" @click="currentTab = 'blood-units'">
        Blood Units
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'external-units' }" @click="currentTab = 'external-units'">
        External Units
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'patient-samples' }" @click="currentTab = 'patient-samples'">
        Patient Samples
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'live-counter' }" @click="currentTab = 'live-counter'">
        Live counter
      </button>
      <!-- <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'blood-pooling' }" @click="currentTab = 'blood-pooling'">
        Blood Pooling
      </button> -->
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'unit-target' }" @click="currentTab = 'unit-target'">
        Unit target
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'external-issuance' }"
        @click="currentTab = 'external-issuance'">
        External Unit Issuance
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'inventory-records' }"
        @click="currentTab = 'inventory-records'">
        Inventory Records
      </button>
      <button class="px-4 py-2 -mb-px font-semibold text-gray-500 border-b-2"
        :class="{ 'border-custom-yellow': currentTab === 'item-types' }" @click="currentTab = 'item-types'">
        Item Type(Category)
      </button>
    </div>
    <component :is="currentTabComponent" ref="currentTabComponent" :search-query="searchQuery"></component>

    <div v-if="showAddItemModal"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
      <div class="w-full max-w-4xl bg-white rounded-lg shadow-lg">
        <div class="flex items-center justify-between px-6 py-4 border-b">
          <h3 class="text-lg font-semibold text-gray-900">Add New Inventory Item</h3>
          <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeAddItemModal">X</button>
        </div>

        <form class="max-h-[75vh] overflow-y-auto px-6 py-4" @submit.prevent="submitInventoryRecord">
          <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Item ID</label>
              <input v-model="inventoryRecordForm.item_id" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md" required>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Item Name</label>
              <input v-model="inventoryRecordForm.item_name" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md" required>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Item Type</label>
              <select v-model="inventoryRecordForm.item_type" class="w-full px-3 py-2 border border-gray-300 rounded-md"
                required>
                <option disabled value="">Select item type</option>
                <option v-for="itemType in itemTypes" :key="getItemTypeUuid(itemType)"
                  :value="getItemTypeUuid(itemType)">
                  {{ itemType.name }}
                </option>
              </select>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Manufacturer</label>
              <div class="relative">
                <input v-model="inventoryRecordForm.manufacturer" type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md" required autocomplete="off"
                  @focus="handleLookupFocus('manufacturer')" @blur="handleLookupBlur('manufacturer')"
                  @input="handleLookupInput('manufacturer')">
                <div v-if="isLookupDropdownVisible('manufacturer')"
                  class="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
                  <div v-if="lookupState.manufacturer.isLoading" class="px-3 py-2 text-sm text-gray-500">
                    Loading suggestions...
                  </div>
                  <template v-else>
                    <button v-for="option in lookupState.manufacturer.suggestions" :key="`manufacturer-${option}`"
                      type="button" class="block w-full px-3 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                      @mousedown.prevent="selectLookupValue('manufacturer', option)">
                      {{ option }}
                    </button>
                    <div v-if="lookupState.manufacturer.noResults" class="px-3 py-2 text-sm text-gray-500">
                      No results found
                    </div>
                    <div v-if="showUseAsNewHint('manufacturer')"
                      class="px-3 py-2 text-sm text-gray-600 border-t border-gray-100">
                      Use "{{ inventoryRecordForm.manufacturer }}" as a new value
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Quantity Received</label>
              <input v-model.number="inventoryRecordForm.quantity_received" type="number" min="0"
                class="w-full px-3 py-2 border border-gray-300 rounded-md" required>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Batch Number</label>
              <input v-model="inventoryRecordForm.batch_number" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md" required>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Serial Number</label>
              <input v-model="inventoryRecordForm.serial_number" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md">
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Storage Location</label>
              <input v-model="inventoryRecordForm.storage_location" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md" required>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Date Received</label>
              <input v-model="inventoryRecordForm.date_received" type="date"
                class="w-full px-3 py-2 border border-gray-300 rounded-md" required>
            </div>
            <div>
              <label class="block mb-1 text-sm font-medium text-gray-700">Expiry Date</label>
              <input v-model="inventoryRecordForm.expiry_date" type="date"
                class="w-full px-3 py-2 border border-gray-300 rounded-md">
            </div>
            <div class="md:col-span-2">
              <label class="block mb-1 text-sm font-medium text-gray-700">Warranty Details</label>
              <input v-model="inventoryRecordForm.warranty_details" type="text"
                class="w-full px-3 py-2 border border-gray-300 rounded-md">
            </div>
            <div class="md:col-span-2">
              <label class="block mb-1 text-sm font-medium text-gray-700">Supplier</label>
              <div class="relative">
                <input v-model="inventoryRecordForm.supplier" type="text"
                  class="w-full px-3 py-2 border border-gray-300 rounded-md" required autocomplete="off"
                  @focus="handleLookupFocus('supplier')" @blur="handleLookupBlur('supplier')"
                  @input="handleLookupInput('supplier')">
                <div v-if="isLookupDropdownVisible('supplier')"
                  class="absolute z-20 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg">
                  <div v-if="lookupState.supplier.isLoading" class="px-3 py-2 text-sm text-gray-500">
                    Loading suggestions...
                  </div>
                  <template v-else>
                    <button v-for="option in lookupState.supplier.suggestions" :key="`supplier-${option}`" type="button"
                      class="block w-full px-3 py-2 text-sm text-left text-gray-700 hover:bg-gray-100"
                      @mousedown.prevent="selectLookupValue('supplier', option)">
                      {{ option }}
                    </button>
                    <div v-if="lookupState.supplier.noResults" class="px-3 py-2 text-sm text-gray-500">
                      No results found
                    </div>
                    <div v-if="showUseAsNewHint('supplier')"
                      class="px-3 py-2 text-sm text-gray-600 border-t border-gray-100">
                      Use "{{ inventoryRecordForm.supplier }}" as a new value
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div class="flex justify-end pt-4 mt-6 space-x-3 border-t">
            <button type="button"
              class="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100"
              @click="closeAddItemModal">
              Cancel
            </button>
            <button type="submit" :disabled="isCreatingInventoryRecord"
              class="px-4 py-2 text-sm font-medium text-white rounded-md bg-custom-yellow hover:bg-custom-yellow-dark disabled:cursor-not-allowed disabled:opacity-60">
              {{ isCreatingInventoryRecord ? "Saving..." : "Save Item" }}
            </button>
          </div>
        </form>
      </div>
    </div>
    <div v-if="showAddItemTypeModal"
      class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50 backdrop-blur-sm">
      <div class="w-full max-w-lg bg-white rounded-lg shadow-lg">
        <div class="flex items-center justify-between px-6 py-4 border-b">
          <h3 class="text-lg font-semibold text-gray-900">Add New Item Type(Category)</h3>
          <button type="button" class="text-gray-500 hover:text-gray-800" @click="closeAddItemTypeModal">X</button>
        </div>
        <form class="px-6 py-4" @submit.prevent="submitItemType">
          <div>
            <label class="block mb-1 text-sm font-medium text-gray-700">Name</label>
            <input v-model="itemTypeForm.name" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md"
              placeholder="Medical Consumable" required>
          </div>
          <div class="flex justify-end pt-4 mt-6 space-x-3 border-t">
            <button type="button"
              class="px-4 py-2 text-sm text-gray-700 border border-gray-300 rounded-md hover:bg-gray-100"
              @click="closeAddItemTypeModal">
              Cancel
            </button>
            <button type="submit" :disabled="isCreatingItemType"
              class="px-4 py-2 text-sm font-medium text-white rounded-md bg-custom-yellow hover:bg-custom-yellow-dark disabled:cursor-not-allowed disabled:opacity-60">
              {{ isCreatingItemType ? "Saving..." : "Save Item Type" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import AlertLayout from "@/components/AlertLayout.vue";
import CustomButton from "@/components/CustomButton.vue";
import BloodUnitsTab from "../tabs/BloodUnitsTab.vue";
import PatientSamplesTab from "../tabs/PatientSamplesTab.vue";
import LiveCounterTab from "../tabs/LiveCounterTab.vue";
import BloodPoolingTab from "../tabs/BloodPoolingTab.vue";
import UnitTargetsForm from "../forms/UnitTargetsForm.vue";
import ExternalUnitIssuanceTab from "../tabs/ExternalUnitIssuanceTab.vue"
import ExternalUnitsTab from "../tabs/ExternalUnitsTab.vue";
import InventoryRecordsTab from "../tabs/InventoryRecordsTab.vue";
import ItemTypesTab from "../tabs/ItemTypesTab.vue";
import api from '@/services/api';

export default {
  name: "InventoryManagementPage",
  components: {
    AlertLayout,
    CustomButton,
    BloodUnitsTab,
    PatientSamplesTab,
    LiveCounterTab,
    BloodPoolingTab,
    UnitTargetsForm,
    ExternalUnitIssuanceTab,
    ExternalUnitsTab,
    InventoryRecordsTab,
    ItemTypesTab
  },
  data() {
    return {
      searchQuery: "",
      isDropdownOpen: false,
      currentTab: "blood-units",
      bloodGroups: [],
      bloodProducts: [],
      itemTypes: [],
      isPageLoading: false,
      showAddItemModal: false,
      isCreatingInventoryRecord: false,
      showAddItemTypeModal: false,
      isCreatingItemType: false,
      itemTypeForm: {
        name: ""
      },
      inventoryRecordForm: {
        item_id: "",
        item_name: "",
        item_type: "",
        manufacturer: "",
        quantity_received: 0,
        batch_number: "",
        serial_number: "",
        storage_location: "",
        date_received: "",
        expiry_date: "",
        warranty_details: "",
        supplier: ""
      },
      lookupState: {
        manufacturer: {
          isLoading: false,
          isOpen: false,
          noResults: false,
          suggestions: [],
          requestId: 0
        },
        supplier: {
          isLoading: false,
          isOpen: false,
          noResults: false,
          suggestions: [],
          requestId: 0
        }
      },
      lookupDebounceTimers: {
        manufacturer: null,
        supplier: null
      },
      filters: {
        bloodGroup: "",
        dateRegistered: '',
        donationProcess: '',
        status: "",
        unitProduct: "",
        facilty: "",
        dateIssued: ""
      },
    };
  },
  computed: {
    currentTabComponent() {
      switch (this.currentTab) {
        case "blood-units":
          return "BloodUnitsTab";
        case "external-units":
          return "ExternalUnitsTab";
        case "patient-samples":
          return "PatientSamplesTab";
        case "live-counter":
          return "LiveCounterTab";
        case "blood-pooling":
          return "BloodPoolingTab";
        case "unit-target":
          return "UnitTargetsForm";
        case "external-issuance":
          return "ExternalUnitIssuanceTab";
        case "inventory-records":
          return "InventoryRecordsTab";
        case "item-types":
          return "ItemTypesTab";
        default:
          return "BloodUnitsTab";
      }
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    token() {
      return this.$store.getters["auth/token"];
    },
  },
  created() {
    // Restore the currentTab from localStorage if it exists
    const savedTab = localStorage.getItem('inventoryManagementTab');
    if (savedTab && [
      'blood-units',
      'external-units',
      'patient-samples',
      'live-counter',
      'unit-target',
      'external-issuance',
      'inventory-records',
      'item-types'
    ].includes(savedTab)) {
      this.currentTab = savedTab;
    }
    this.fetchBloodGroups();
    this.fetchBloodProducts();
    this.fetchItemTypes();
  },
  watch: {
    // Watch for changes to currentTab and save to localStorage
    currentTab(newTab) {
      localStorage.setItem('inventoryManagementTab', newTab);
    }
  },
  methods: {
    openAddItemTypeModal() {
      this.showAddItemTypeModal = true;
    },

    closeAddItemTypeModal() {
      this.showAddItemTypeModal = false;
      this.itemTypeForm = { name: "" };
    },

    async submitItemType() {
      this.isCreatingItemType = true;
      try {
        await api.createItemType({ ...this.itemTypeForm });
        this.showAddItemTypeModal = false;
        this.itemTypeForm = { name: "" };
        await this.fetchItemTypes();
        this.currentTab = "item-types";
        if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.fetchItemTypes === "function") {
          await this.$refs.currentTabComponent.fetchItemTypes();
        }
      } catch (error) {
        console.error("Error creating item type:", error);
      } finally {
        this.isCreatingItemType = false;
      }
    },

    openAddItemModal() {
      this.showAddItemModal = true;
      this.fetchItemTypes();
    },

    closeAddItemModal() {
      this.showAddItemModal = false;
    },

    async submitInventoryRecord() {
      this.isCreatingInventoryRecord = true;
      try {
        await api.createInventoryRecord({ ...this.inventoryRecordForm });
        this.showAddItemModal = false;
        this.currentTab = "inventory-records";
        if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.fetchRecords === "function") {
          await this.$refs.currentTabComponent.fetchRecords();
        }
      } catch (error) {
        console.error("Error creating inventory record:", error);
      } finally {
        this.isCreatingInventoryRecord = false;
      }
    },

    handleLookupFocus(field) {
      this.lookupState[field].isOpen = true;
      this.handleLookupInput(field);
    },

    handleLookupBlur(field) {
      window.setTimeout(() => {
        this.lookupState[field].isOpen = false;
      }, 150);
    },

    handleLookupInput(field) {
      const value = (this.inventoryRecordForm[field] || "").trim();
      this.lookupState[field].isOpen = true;

      if (this.lookupDebounceTimers[field]) {
        clearTimeout(this.lookupDebounceTimers[field]);
      }

      if (!value) {
        this.lookupState[field].isLoading = false;
        this.lookupState[field].suggestions = [];
        this.lookupState[field].noResults = false;
        return;
      }

      this.lookupDebounceTimers[field] = window.setTimeout(() => {
        this.fetchInventoryLookup(field);
      }, 400);
    },

    async fetchInventoryLookup(field) {
      const query = (this.inventoryRecordForm[field] || "").trim();
      if (!query) return;

      this.lookupState[field].isLoading = true;
      this.lookupState[field].noResults = false;
      const currentRequestId = this.lookupState[field].requestId + 1;
      this.lookupState[field].requestId = currentRequestId;

      try {
        const response = await api.queryInventoryRecords({ [field]: query });
        if (this.lookupState[field].requestId !== currentRequestId) return;

        const rawValues = Array.isArray(response)
          ? response
          : response?.data || response?.inventory_records || [];

        const distinctValues = [...new Set(
          rawValues
            .map((entry) => (typeof entry === "string" ? entry : entry?.[field]))
            .filter((value) => typeof value === "string" && value.trim() !== "")
            .map((value) => value.trim())
        )].slice(0, 10);

        this.lookupState[field].suggestions = distinctValues;
        this.lookupState[field].noResults = distinctValues.length === 0;
      } catch (error) {
        if (this.lookupState[field].requestId === currentRequestId) {
          this.lookupState[field].suggestions = [];
          this.lookupState[field].noResults = true;
        }
        console.error(`Error fetching ${field} suggestions:`, error);
      } finally {
        if (this.lookupState[field].requestId === currentRequestId) {
          this.lookupState[field].isLoading = false;
        }
      }
    },

    selectLookupValue(field, value) {
      this.inventoryRecordForm[field] = value;
      this.lookupState[field].isOpen = false;
    },

    isLookupDropdownVisible(field) {
      const state = this.lookupState[field];
      return state.isOpen && (
        state.isLoading ||
        state.suggestions.length > 0 ||
        state.noResults ||
        this.showUseAsNewHint(field)
      );
    },

    showUseAsNewHint(field) {
      const typedValue = (this.inventoryRecordForm[field] || "").trim();
      if (!typedValue) return false;
      const lowerTypedValue = typedValue.toLowerCase();
      return !this.lookupState[field].suggestions.some(
        (option) => option.toLowerCase() === lowerTypedValue
      );
    },

    async fetchBloodGroups() {
      try {
        const response = await api.getBloodGroups();
        this.bloodGroups = response;
      } catch (error) {
        console.error('Error fetching blood groups:', error);
      }
    },

    async fetchBloodProducts() {
      try {
        const response = await api.getUnitProducts();
        this.bloodProducts = response;
      } catch (error) {
        console.error('Error fetching blood products:', error);
      }
    },

    async fetchItemTypes() {
      try {
        const response = await api.getItemTypes();
        this.itemTypes = Array.isArray(response)
          ? response
          : response?.data || response?.item_types || [];
      } catch (error) {
        console.error("Error fetching item types:", error);
      }
    },

    getItemTypeUuid(itemType) {
      return itemType?.uuid || itemType?.item_type_id || itemType?.id || "";
    },

    async handleNewUnitRegistration() {
      this.isPageLoading = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({ name: 'NewExternalUnit' });
      } catch {
        this.isPageLoading = false;
      }
    },

    async handleNewExternalUnitRegistration() {
      this.isPageLoading = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({ name: 'NewExternalUnitScreening' });
      } catch {
        this.isPageLoading = false;
      }
    },

    async handleBloodPooling() {
      if (this.currentTab === 'blood-pooling') {
        // Already on blood-pooling tab, try to initiate pooling
        this.$nextTick(() => {
          if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.initiatePooling === 'function') {
            this.$refs.currentTabComponent.initiatePooling();
          } else {
            // Switch to blood-pooling tab and show the view
            this.currentTab = 'blood-pooling';
          }
        });
      } else {
        // Switch to blood-pooling tab
        this.currentTab = 'blood-pooling';
      }
    },

    async handleLiveCounter() {
      this.isPageLoading = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({ name: 'LiveCounterTallyPage' });
      } catch {
        this.isPageLoading = false;
      }
    },

    filterExpiry() {
      if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.filterExpiry === 'function') {
        this.$refs.currentTabComponent.filterExpiry();
      }
    },

    async handleNewExterbalUnitIssuance() {
      this.isPageLoading = true;
      try {
        await new Promise(resolve => setTimeout(resolve, 500));
        this.$router.push({ name: 'ExternalUnitIssuanceForm' });
      } catch {
        this.isPageLoading = false;
      }
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    applyFilters() {
      console.log('Applying filters:', this.filters);
      this.applyFiltersToCurrentTab();
      this.isDropdownOpen = false;
    },

    applyFiltersToCurrentTab() {
      if (this.$refs.currentTabComponent && typeof this.$refs.currentTabComponent.applyFilters === 'function') {
        this.$refs.currentTabComponent.applyFilters(this.filters);
      } else {
        console.error('applyFilters method not found on current tab component');
      }
    },

    cancelFilters() {
      this.filters = {
        bloodGroup: "",
        dateRegistered: '',
        donationProcess: '',
        status: "",
        unitProduct: ""
      };
      this.applyFiltersToCurrentTab();
      this.isDropdownOpen = false;
    },
  },

  mounted() { },
  beforeUnmount() {
    Object.values(this.lookupDebounceTimers).forEach((timerId) => {
      if (timerId) {
        clearTimeout(timerId);
      }
    });
  },

};
</script>

<style lang="css" scoped></style>